import { render, staticRenderFns } from "./Firma.vue?vue&type=template&id=69cd83ae&scoped=true"
import script from "./Firma.vue?vue&type=script&lang=ts"
export * from "./Firma.vue?vue&type=script&lang=ts"
import style0 from "./Firma.vue?vue&type=style&index=0&id=69cd83ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd83ae",
  null
  
)

export default component.exports